import { extendTheme } from "@chakra-ui/react";
import { theme as coreTheme } from "am-tax-fe-core";

// const themeOverrides: Partial<ChakraTheme> = {
const themeOverrides = {
    semanticTokens: {
        colors: {
            input: {
                bg: { default: "white", _dark: "gray.800" },
                borderColor: { default: "gray.200", _dark: "gray.600" },
                focusBorderColor: { default: "blue.200", _dark: "blue.400" },
                sendButtonHoverBg: { default: "blue.50", _dark: "blue.900" },
                gradientBg: {
                    default: "linear-gradient(to top, rgba(255,255,255, 1) 0%, rgba(255,255,255, .8) 50%, rgba(255,255,255,.8) 80%, rgba(255,255,255,0) 100%)",
                    _dark: "linear-gradient(to top, rgba(26,32,44, 1) 0%, rgba(26,32,44, .8) 50%, rgba(26,32,44,.8) 80%, rgba(26,32,44,0) 100%)",
                },
            },
            contextBar: {
                bgActive: { default: "white", _dark: "gray.800" },
                bgInactive: { default: "blue.300", _dark: "blue.600" },
                colorActive: { default: "gray.300", _dark: "gray.400" },
                colorInactive: { default: "blue.100", _dark: "blue.200" },
                menuButtonHoverBg: { default: "gray.50", _dark: "gray.700" },
                menuButtonActiveBg: { default: "blue.400", _dark: "blue.500" },
                menuItemTextColor: { default: "gray.800", _dark: "gray.200" },
            },
            sidebar: {
                bg: { default: "gray.50", _dark: "gray.900" },
                borderColor: { default: "gray.200", _dark: "gray.700" },
                buttonHoverBg: { default: "gray.100", _dark: "gray.700" },
                buttonTextColor: { default: "gray.700", _dark: "gray.300" },
                headingColor: { default: "gray.800", _dark: "gray.100" },
                textColor: { default: "gray.600", _dark: "gray.400" },
                labelColor: { default: "gray.500", _dark: "gray.500" },
                documentItemBg: { default: "white", _dark: "gray.800" },
                documentIconColor: { default: "gray.400", _dark: "gray.500" },
                disclaimerBg: { default: "blue.50", _dark: "blue.900" },
                disclaimerTextColor: { default: "blue.700", _dark: "blue.200" },
            },
            chat: {
                bg: { default: "white", _dark: "gray.800" },
                userMessageBg: { default: "blueAlpha.200", _dark: "blue.700" },
                aiMessageBg: { default: "gray.50", _dark: "gray.700" },
                pulseLoaderColor: { default: "blueAlpha.700", _dark: "blue.300" },
            },
            table: {
                headerBg: { default: "gray.100", _dark: "gray.700" },
                headerColor: { default: "gray.800", _dark: "gray.100" },
                borderColor: { default: "gray.200", _dark: "gray.600" },
                rowOddBg: { default: "gray.50", _dark: "whiteAlpha.50" },
                rowHoverBg: { default: "gray.100", _dark: "gray.600" },
            },
            source: {
                borderColor: { default: "gray.200", _dark: "gray.600" },
                textColor: { default: "gray.700", _dark: "gray.300" },
                secondaryTextColor: { default: "gray.600", _dark: "gray.400" },
                itemBg: { default: "gray.50", _dark: "gray.800" },
                itemHoverBg: { default: "blue.50", _dark: "blue.900" },
                itemBorderColor: { default: "gray.200", _dark: "gray.700" },
                itemHoverBorderColor: { default: "blue.200", _dark: "blue.500" },
            },
        },
    },
    fonts: {
        heading: "'Helvetica Neue', Helvetica, Arial, sans-serif",
        body: "'Helvetica Neue', Helvetica, Arial, sans-serif",
    },
    fontSizes: {
        "2xs": "0.625rem",
        xs: "0.75rem",
        sm: "0.875rem",
        md: "1rem",
        lg: "1.125rem",
    },
    fontWeights: {
        normal: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
    },
    lineHeights: {
        compact: "1.4",
        normal: "1.5",
        relaxed: "1.6",
    },
    space: {
        2: "0.5rem",
        3: "0.75rem",
        4: "1rem",
        6: "1.5rem",
        8: "2rem",
        10: "2.5rem",
    },
    radii: {
        sm: "0.25rem",
        md: "0.5rem",
        full: "9999px",
    },
    components: {
        Button: {
            baseStyle: {
                borderRadius: "md",
                fontWeight: "semibold",
            },
            sizes: {
                sm: {
                    fontSize: "sm",
                },
            },
            variants: {
                ghost: {
                    _hover: {
                        bg: "sidebar.buttonHoverBg",
                    },
                },
                link: {
                    borderRadius: "sm",
                },
            },
        },
        Input: {
            variants: {
                filled: {
                    field: {
                        bg: "input.bg",
                        borderColor: "input.borderColor",
                        borderRadius: "md",
                        _focus: {
                            borderColor: "input.focusBorderColor",
                        },
                    },
                },
            },
        },
        Textarea: {
            variants: {
                filled: {
                    bg: "input.bg",
                    borderColor: "input.borderColor",
                    borderRadius: "md",
                    _focus: {
                        borderColor: "input.focusBorderColor",
                    },
                },
            },
        },
        Menu: {
            baseStyle: {
                list: {
                    bg: "input.bg",
                    borderColor: "input.borderColor",
                },
                item: {
                    color: "contextBar.menuItemTextColor",
                    _hover: {
                        bg: "contextBar.menuButtonHoverBg",
                    },
                    _focus: {
                        bg: "contextBar.menuButtonHoverBg",
                    },
                },
            },
        },
        Card: {
            baseStyle: {
                container: {
                    bg: "chat.bg",
                    borderColor: "sidebar.borderColor",
                    borderRadius: "md",
                },
            },
        },
    },
};

export const theme = extendTheme(coreTheme, themeOverrides);
